document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-copy-code]');
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const code = btn.dataset.copyCode;
      if (!code) return;

      navigator.clipboard.writeText(code);

      btn.classList.add('active');

      clearTimeout(btn._copyTimeout);
      btn._copyTimeout = setTimeout(() => {
        btn.classList.remove('active');
      }, 3000);
    });
  });
});